// utils/crypto/pem.ts 

export function pemToArrayBuffer(pem: string): ArrayBuffer {
  const b64 = pem.replace(/-----(BEGIN|END) [A-Z ]+-----/g, "").replace(/\s+/g, "");
  const binStr = atob(b64);
  const bytes = new Uint8Array(binStr.length);
  for (let i = 0; i < binStr.length; i++) bytes[i] = binStr.charCodeAt(i);
  return bytes.buffer;
}

export function arrayBufferToPem(buf: ArrayBuffer, label: string): string {
  const b64 = btoa(String.fromCharCode(...new Uint8Array(buf)));
  const lines = b64.match(/.{1,64}/g)?.join("\n");
  return `-----BEGIN ${label}-----\n${lines}\n-----END ${label}-----`;
}

export function spkiToPublicPem(spki: ArrayBuffer): string {
  return arrayBufferToPem(spki, "PUBLIC KEY");
}

export function pkcs8ToPrivatePem(pkcs8: ArrayBuffer): string {
  return arrayBufferToPem(pkcs8, "PRIVATE KEY");
}
